export default __webpack_public_path__ + "static/media/bagw.c8d1e0e6.png";